import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DefineAccountviewModel, AccountDefiningModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { GPackagesViewModel } from 'src/app/viewmodels/g-packages/GPackagesViewModel';
import { G_SaleMasterViewModel } from 'src/app/viewmodels/g-sale/G_SaleMasterViewModel';
import { GVechileViewModel } from 'src/app/viewmodels/g-vehicle/GVechileViewModel';
import { GItemDefiningViewModel } from 'src/app/viewmodels/g-item/GItemDefiningViewModel';
import { ActivatedRoute, Router } from '@angular/router';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { GPackageItemViewModel } from 'src/app/viewmodels/g-packages/GPackageItemViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { G_TagsViewModel } from 'src/app/viewmodels/g-sale/G_TagsViewModel';
import { G_Installment_View_Model } from 'src/app/viewmodels/g-purchase/G_Installment_View_Model';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { GPackagesModel, SaveGInstallmentRequest, SaveSaleMasterRequest, TagsModel } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { GPackageItemModel, SaveGVehicleRequest, SaveItemRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-payment-status-detail-view',
  templateUrl: './payment-status-detail-view.component.html',
  styleUrls: ['./payment-status-detail-view.component.scss']
})
export class PaymentStatusDetailViewComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  modalRefLv3: BsModalRef;
  modalRef: BsModalRef;
  public vmListItems: any = [];
  @Input() public modal_title: any;
  @Input() public vmP: AccountDefiningModel;
  @Input() public vmp: GPackagesModel;
  public vm: SaveSaleMasterRequest = new SaveSaleMasterRequest();
  public vmI: SaveGInstallmentRequest = new SaveGInstallmentRequest();
  public vmDetail: number = 0;
  private submitted = false;
  public component_Title = 'Payment Status Detail';
  public customerDetail: any = [];
  public selectedcustomerDetail: any = [];
  public ccustomerDetail = 'customerDetail';
  public address: any;
  public files: File[] = [];
  public vehicleDetail: any = [];
  public selectedTagsList: any = [];
  public cvehicleDetail = 'vehicleDetail';
  public selectedvehicleDetail: any = [];
  public itemVm: SaveGVehicleRequest = new SaveGVehicleRequest();
  bsmRef: any;
  @Output() onSubmitted = new EventEmitter<any>();
  public tags: any = [];
  public selectedTagList: any = [];
  public spareParts: any = [];
  public selectedSpareParts: any = [];

  public itemTypes = [];
  public ssItemVm = new GItemDefiningViewModel();
  public SelectedItemServices: any = [];
  public citems: any = 'items';
  public selectedDate: any;
  public DisableSave: boolean = false;
  public EnableNext: boolean = false;
  public calingUrl: string;
  public urlId: string;
  public client: any;
  constructor(
    private route: ActivatedRoute,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    public _router: Router,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.client = this._localStorageService.get("com");
    let selectedSaprePartsList: any = [];
    let selectedTagLists: any = [];
    let selectedVehicle: any = [];
    let selectedCustomer: any = [];
    let date = new Date();
    document.getElementById("date").innerHTML = date.toLocaleDateString();
    this.calingUrl = this._router.url;

    this.route.queryParams.subscribe(params => {
      this.urlId = params['id'];


    });
    // this._jq.showSpinner(true);
    this.spinner.show();
    debugger
    this._uow.gSaleService.GetGSaleByIdAsync(this.urlId).subscribe((res: any) => {
      this.vm = res;
      console.log(res);
      this.spinner.hide();
      debugger
      let veh = new SaveGVehicleRequest();
      veh.id = this.vm.gVehicle.id;
      veh.name = this.vm.gVehicle.name;
      selectedVehicle.push(veh);
      this.selectedvehicleDetail = selectedVehicle;

      let cust = new AccountDefiningModel();
      cust.id = this.vm.gCustomer.id;
      cust.accTitle = this.vm.gCustomer.name;
      selectedCustomer.push(cust);
      this.selectedcustomerDetail = selectedCustomer;

      this.vm.spareParts.forEach(x => {

        let ab = new GPackageItemModel();
        ab.quantity = x.quantity;
        ab.ssItemDefining = new ItemViewModel1(x.item.id, x.item.name);
        ab.discountPercentage = x.discount;
        ab.salePrice = 0;
        ab.salePrice = x.salePrice;
        ab.amount = 0;
        ab.amount = x.totalAmount;
        ab.discountAmount = 0;
        ab.discountAmount = x.discountAmount;
        this.vmp.spareParts.push(ab);
        let partssSelected = new SaveItemRequest();
        partssSelected.id = x.item.id;
        partssSelected.name = x.item.name;
        selectedSaprePartsList.push(partssSelected);
        //this.InventoryCheck(x.FK_G_Item_Id.Id);
        this.discountChange(ab, 0);
      });
      this.selectedSpareParts = selectedSaprePartsList;
      this.vm.salesTagsList.forEach(x => {
        let selectedTag = new TagsModel();
        selectedTag.id = x.id;
        selectedTag.fkTagId = x.fkTagId;
        selectedTag.name = x.name;
        selectedTagLists.push(selectedTag);
      });
      this.selectedTagsList = selectedTagLists;
    });

    if (this.itemVm.tagList !== undefined && this.itemVm.tagList.length > 0) {
      this.itemVm.tagList.forEach(x => {
        this.selectedTagList.push(new ItemViewModel1(x.id, x.name));
      });
    }
    if (this.itemVm == undefined) {
      this.itemVm = new SaveGVehicleRequest();
      this.vehicleDetail = [];
      this.selectedvehicleDetail = [];
    } else {

    }
    if (this.vmP == undefined) {
      this.vmP = new AccountDefiningModel();
      this.customerDetail = [];
      this.selectedcustomerDetail = [];
    } else {

    }
    if (this.modal_title == undefined) {
      this.modal_title = 'Sale';
    }
    if (this.vmp == undefined) {
      this.vmp = new GPackagesModel();
      this.vm = new SaveSaleMasterRequest();
      this.vmp.spareParts = [];
      this.vm.paymentType = 1;
      this.vm.statusType = new ItemViewModel1(8, "SaleInvoice");
    } else {
      if (this.vm.salesTagsList !== undefined && this.vm.salesTagsList.length > 0) {
        this.vm.salesTagsList.forEach(x => {
          this.selectedTagsList.push(new ItemViewModel(x.id, x.name));
        });
      }

      if (this.vmp.spareParts !== undefined && this.vmp.spareParts.length > 0) {
        this.vmp.spareParts.forEach(x => {
          this.selectedSpareParts.push(new ItemViewModel1(x.ssItemDefining.id, x.ssItemDefining.name));
        });
      }
    }

    // this.getRegNo();
    // this.getCustomers();
    // this.getRequisitions();
    // this.getTags();
    // this.getSpareParts();

  }

  // getRegNo() {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.GetList().subscribe((res: any) => {
  //     this.vehicleDetail = res;
  //     // this.itemVm.RegistraionNumber = res;
  //     console.log(res);
  //     this._jq.showSpinner();
  //     // this.itemVm.RegistraionNumber = res.code;
  //   }, (error) => {
  //     this._uow.logger.log(error);
  //     this._jq.showSpinner();
  //   });
  // }

  // getCustomers() {
  //   let Customer = "Customer";
  //   if (this.vm.paymentType === 2) {
  //     Customer = "Cash";
  //   }
  //   console.log(this.selectedcustomerDetail);
  //   this._jq.showSpinner(true);
  //   this._uow.customerService.GetListSuplier(Customer).subscribe((res: any) => {
  //     // console.log(res);
  //     this._jq.showSpinner();
  //     this.customerDetail = res.DtlList;
  //   }, (error) => {
  //     this._uow.logger.log(error);
  //     this.customerDetail = [];
  //     this._jq.showSpinner();
  //   });
  // }

  // getRequisitions() {
  //   this._uow.vehicleService.GetList().subscribe((res: any) => {
  //     this.vehicleDetail = res;
  //   }, (error) => {
  //     this._uow.logger.log(error);
  //     this.vehicleDetail = [];
  //   });
  // }

  // getTags() {
  //   this._uow.tagsService.GetList().subscribe((res: any) => { this.tags = res; }, (err) => console.log(err));
  // }

  // getSpareParts() {
  //   this._uow.itemService.GetSSItemDefiningByItemType('Spare-Parts').subscribe((res: any) => {
  //     this.spareParts = res;
  //     console.log(res);

  //   }, (err) => {
  //     this._uow.logger.log(err);
  //     this.spareParts = [];
  //   });
  // }

  discountChange(e, i?) {
    debugger
    let discountAMmount = ((e.DescountPercentage * e.SalePrice)) / 100;
    e.DescountAmmount = discountAMmount;
    e.DiscountAmount = e.SalePrice - e.DescountAmmount;
    e.Amount = e.DiscountAmount * e.Quantity;
    let saledtl = this.vm.saleDetails.find(x => x.item.id === e.ssItemDefining.id);
    if (saledtl != undefined) {
      saledtl.discountAmount = e.DescountAmmount;
      saledtl.discount = e.DescountPercentage;
      saledtl.discountedRate = e.DiscountAmount;
      saledtl.totalAmount = e.Amount;
    }
    this.vatChanged();
  }

  vatChanged() {
    if (this.vmDetail > -1) {
      if (this.vm.saleDetails !== undefined && this.vm.saleDetails.length > 0) {
        this.vm.saleDetails.forEach(x => {
          x.vatValue = this.vmDetail;
          x.vatAmount = ((x.totalAmount / 100) * this.vmDetail);
        });
      }
      if (this.vmp.spareParts !== undefined && this.vmp.spareParts.length > 0) {
        this.vmp.spareParts.forEach(x => {
          x.vatAmount = ((x.salePrice / 100) * this.vmDetail);
          x.totalAmount = x.salePrice + x.vatAmount;
        });
      }
      this.calculateTotals();
    }
  }

  public DiscountTotal = 0;
  public partsAmount = 0;
  public serviceAmount = 0;
  public TotalPayable = 0;
  public TotalVat = 0;
  public TotalPayableAfterVat = 0;
  calculateTotals() {
    debugger
    this.TotalPayableAfterVat = 0;
    this.TotalVat = 0;
    this.DiscountTotal = 0;
    this.TotalPayable = 0;
    this.partsAmount = 0;
    this.serviceAmount = 0;
    this.vmp.serviceAmount = 0;
    this.vmp.discountAmount = 0;
    this.vmp.partsAmount = 0;
    if (this.vm.saleDetails !== undefined && this.vm.saleDetails.length > 0) {
      this.vm.spareParts.forEach(x => {
        // this.vmp.PartsAmount += x.Amount;
        this.TotalVat += x.vatAmount;
        if (x.discountAmount >= 0) {
          // this.vmp.DiscountAmount += (x.DiscountAmount * x.Quantity);
          this.DiscountTotal += (x.discountAmount * x.quantity);

        }
      });
      this.vm.services.forEach(x => {
        // this.vmp.ServiceAmount += x.Amount;
        this.TotalVat += x.vatAmount;
        this.serviceAmount += x.totalAmount;
        if (x.discountAmount >= 0) {
          this.DiscountTotal += (x.discountAmount * x.quantity);
          // this.vmp.DiscountAmount += (x.DiscountAmount * x.Quantity);
        }
      });
    }
    this.vmp.packageAmount = this.vmp.partsAmount + this.TotalVat;
  }

  onItemSubmitted(e) {
    if (e == true) {
      //this.getList();
      //this.getTags();
      this._jq.showSpinner(false);
    }
  }

  // getList() {
  //   this._jq.showSpinner(true);
  //   this._uow.vehicleService.GetList().subscribe((res: any) => {
  //     this.vmListItems = res.DtlList;
  //     console.log(res);
  //     this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //     this._jq.showSpinner();
  //   });
  // }
  openSaleModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._uow.modalServiceEx.show(template);
    }
    this.modalRef.setClass('modal-xl');
    // if (lvl == 2) {
    //   this.modalRefLv2 = this._modalService.show(template);
    // }
  }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openSaleModal(template, 1);
    if (model !== undefined) {
      this.vm = model;
    } else {
      this.vm = new SaveSaleMasterRequest();
    }
  }

}
